import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useProduct } from '~/composables/_next/useProduct';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useCustomizer } from '~/composables/_next/stores/useCustomizerStore';
import { getSellable } from '~/helpers/productCardMethods';
import { isProductAvailableInCountry } from '@/utils/ProductAvailability';
import { getProductAttributes } from '~/utils/commercetools/attributes';
import { useLocalization } from '~/composables/_next/useLocalization';
export var useCustomizerInit = function useCustomizerInit() {
  var _useNuxt2App = useNuxt2App(),
    $trackers = _useNuxt2App.$trackers;
  var _useLocalization = useLocalization(),
    country = _useLocalization.country,
    locale = _useLocalization.locale;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useCustomizer = useCustomizer(),
    setNeutralBases = _useCustomizer.setNeutralBases,
    toggleLoading = _useCustomizer.toggleLoading;
  var contentfulResponse = ref(null);
  var _useProduct = useProduct('customizerNeutralBases'),
    searchProducts = _useProduct.search,
    customizerProducts = _useProduct.products;
  var initNeutralBaseCustomizer = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _contentfulResponse$v, _contentfulResponse$v2, _contentfulResponse$v3, customizerNeutralBaseCollection, skus, payload;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            toggleLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return client.contentful.getCustomizerNeutralBaseCollection.query({
              locale: locale
            });
          case 4:
            contentfulResponse.value = _context.sent;
            customizerNeutralBaseCollection = ((_contentfulResponse$v = contentfulResponse.value) === null || _contentfulResponse$v === void 0 ? void 0 : (_contentfulResponse$v2 = _contentfulResponse$v.data) === null || _contentfulResponse$v2 === void 0 ? void 0 : (_contentfulResponse$v3 = _contentfulResponse$v2.customizerNeutralBaseCollection) === null || _contentfulResponse$v3 === void 0 ? void 0 : _contentfulResponse$v3.items) || [];
            skus = customizerNeutralBaseCollection.map(function (item) {
              return item.productSku;
            });
            if (!skus.length) {
              _context.next = 10;
              break;
            }
            _context.next = 10;
            return searchProducts({
              skus: skus,
              perPage: skus.length
            });
          case 10:
            payload = customizerNeutralBaseCollection.reduce(function (acc, item) {
              var product = customizerProducts.value.find(function (product) {
                return product.sku === item.productSku;
              });
              if (!product || !getSellable(product) || !isProductAvailableInCountry(product, country)) {
                return acc;
              }
              var attributes = getProductAttributes(product, ['capacity', 'capacity-unit']);
              acc.push(_objectSpread(_objectSpread({}, item), {}, {
                product: product,
                cardAttributes: {
                  quantity: "".concat(attributes.capacity).concat(attributes['capacity-unit']),
                  title: (product === null || product === void 0 ? void 0 : product._name) || ''
                }
              }));
              return acc;
            }, []);
            if (payload.length) {
              setNeutralBases(payload);
            }
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            console.error('Failed to initialize customizer:', _context.t0);
          case 17:
            _context.prev = 17;
            toggleLoading(false);
            return _context.finish(17);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 14, 17, 20]]);
    }));
    return function initNeutralBaseCustomizer() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    initNeutralBaseCustomizer: initNeutralBaseCustomizer
  };
};